// Vendor
import { EventEmitter } from '@angular/core';
import { Store } from '@ngrx/store';
// NgRx actions / selectors / reducers
import { setRiskProfile } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/risk-profile/risk-profile.actions';
import { resetAllCustomPdfReportItems } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/actions';
import { getCurrentWizardStep, getCurrentWizardStepIndex, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/selectors';
import { CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/reducer';
import { decrementCurrentWizardStep, incrementCurrentWizardStep, } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/state/wizard-step/wizard-step.actions';
// Interfaces
import { CustomPDFReportModalEventName } from 'CustomPDFReportsApp/ts/features/custom-pdf-report-modal/enums/custom-pdf-report-modal-event-name.enum';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
const _c0 = a0 => ({ disabled: a0 });
const _c1 = a0 => ({ "show": a0 });
const _forTrack0 = ($index, $item) => $item.riskProfile.id;
function SelectRiskProfileModalComponent_For_6_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 17);
} if (rf & 2) {
    i0.ɵɵproperty("name", "icon-check");
} }
function SelectRiskProfileModalComponent_For_6_Conditional_9_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵlistener("click", function SelectRiskProfileModalComponent_For_6_Conditional_9_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r4); const riskProfileItem_r2 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectRiskProfileItem(riskProfileItem_r2)); });
    i0.ɵɵelement(1, "div", 21);
    i0.ɵɵelementStart(2, "div", 22);
    i0.ɵɵelement(3, "img", 23);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const riskProfileItem_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", riskProfileItem_r2.riskProfile.description, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", riskProfileItem_r2.riskProfile.benchmark_asset_allocation_chart_image_url, i0.ɵɵsanitizeUrl);
} }
function SelectRiskProfileModalComponent_For_6_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 11)(2, "div", 12)(3, "button", 13);
    i0.ɵɵlistener("click", function SelectRiskProfileModalComponent_For_6_Template_button_click_3_listener() { const riskProfileItem_r2 = i0.ɵɵrestoreView(_r1).$implicit; return i0.ɵɵresetView(riskProfileItem_r2.showMore = !riskProfileItem_r2.showMore); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵlistener("click", function SelectRiskProfileModalComponent_For_6_Template_div_click_5_listener() { const riskProfileItem_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectRiskProfileItem(riskProfileItem_r2)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 16);
    i0.ɵɵlistener("click", function SelectRiskProfileModalComponent_For_6_Template_div_click_6_listener() { const riskProfileItem_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.selectRiskProfileItem(riskProfileItem_r2)); });
    i0.ɵɵtemplate(7, SelectRiskProfileModalComponent_For_6_Conditional_7_Template, 1, 1, ":svg:svg", 17);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 18);
    i0.ɵɵtemplate(9, SelectRiskProfileModalComponent_For_6_Conditional_9_Template, 4, 2, "div", 19);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const riskProfileItem_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1, riskProfileItem_r2.showMore));
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-collapse");
    i0.ɵɵadvance();
    i0.ɵɵproperty("textContent", riskProfileItem_r2.riskProfile.name);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(riskProfileItem_r2.selected ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c1, riskProfileItem_r2.showMore));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.open ? 9 : -1);
} }
function SelectRiskProfileModalComponent_Conditional_11_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵlistener("click", function SelectRiskProfileModalComponent_Conditional_11_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.back()); });
    i0.ɵɵtext(1, "Back");
    i0.ɵɵelementEnd();
} }
/**
 * Select Risk Profile Modal Component
 *
 * Modal with list of expandable risk profiles.
 *
 * Input Properties:
 *  riskProfiles: List of risk profiles.
 *
 * Output Properties:
 *  broadcastWizardStepEvent: Emits when the wizard should move to the previous step or next step.
 */
export class SelectRiskProfileModalComponent {
    constructor(store) {
        this.store = store;
        this.riskProfiles = [];
        this.broadcastWizardStepEvent = new EventEmitter();
        this.open = false;
        this.currentWizardStepIndex = 0;
        this.currentWizardStep = null;
        this.disableSubmission = true;
        this.mapStateToComponent = (state) => {
            this.currentWizardStepIndex = getCurrentWizardStepIndex(state);
            this.currentWizardStep = getCurrentWizardStep(state);
            if (!this.open &&
                this.currentWizardStep?.eventName === CustomPDFReportModalEventName.SHOW_SELECT_RISK_PROFILE_MODAL) {
                this.openModal();
            }
            if (this.riskProfiles?.length > 0) {
                this.riskProfileItems = this.riskProfiles.map((riskProfile) => ({
                    riskProfile,
                    showMore: false,
                    selected: state.riskProfile ? riskProfile.id === state.riskProfile.id : false,
                }));
                this.disableSubmission = !state.riskProfile;
            }
        };
        this.storeSubscription = this.store
            .select(CUSTOM_PDF_REPORT_MODAL_STATE_SLICE_KEY)
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    selectRiskProfileItem(riskProfileItem) {
        // eslint-disable-next-line no-param-reassign
        riskProfileItem.selected = !riskProfileItem.selected;
        this.disableSubmission = !riskProfileItem.selected;
        if (riskProfileItem.selected) {
            this.riskProfileItems.forEach((item) => {
                if (item.riskProfile.id !== riskProfileItem.riskProfile.id) {
                    // eslint-disable-next-line no-param-reassign
                    item.selected = false;
                }
            });
        }
    }
    openModal() {
        this.open = true;
    }
    exitModalHandler() {
        this.store.dispatch(resetAllCustomPdfReportItems());
        this.closeModal();
    }
    closeModal() {
        this.open = false;
    }
    back() {
        this.store.dispatch(decrementCurrentWizardStep());
        this.broadcastWizardStepEvent.emit();
        this.exitModalHandler();
    }
    forward() {
        const selectedRiskProfileItem = this.riskProfileItems.find((item) => item.selected);
        if (selectedRiskProfileItem) {
            this.store.dispatch(setRiskProfile({ riskProfile: selectedRiskProfileItem.riskProfile }));
            this.store.dispatch(incrementCurrentWizardStep());
            this.broadcastWizardStepEvent.emit();
            this.closeModal();
        }
    }
}
SelectRiskProfileModalComponent.ɵfac = function SelectRiskProfileModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SelectRiskProfileModalComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
SelectRiskProfileModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SelectRiskProfileModalComponent, selectors: [["ycn-select-risk-profile-modal"]], inputs: { riskProfiles: "riskProfiles" }, outputs: { broadcastWizardStepEvent: "broadcastWizardStepEvent" }, standalone: false, decls: 13, vars: 8, consts: [[3, "closeModalHandler", "modalBaseClass", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "plates", "pl-20", "pr-20", "pt-20", "pb-10", "bg-panel"], [1, "plate-container"], [1, "modal-footer"], [1, "modal-footer-actions"], [1, "btn", "btn-text", 3, "click"], [1, "btn", "btn-secondary"], [1, "btn", "btn-primary", 3, "click", "ngClass", "innerText"], [1, "plate", "plate-collapsible", "plate-white"], [1, "plate-header"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-toggler", 3, "click", "ngClass"], ["ycnIcon", "", 1, "icon-collapse", "fill-current", "text-gray-70", 3, "name"], [1, "plate-title", "align-items-center", "text-bold", 2, "margin", "-10px 0", 3, "click", "textContent"], [1, "plate-controls", 3, "click"], ["ycnIcon", "", 1, "fill-current", "text-blue", "pointer-events-none", "mr-1", 3, "name"], [1, "plate-content", "pr-40", "collapse", 3, "ngClass"], [1, "row", "pt-20", "pb-20"], [1, "row", "pt-20", "pb-20", 3, "click"], [1, "col-9", 3, "innerHTML"], [1, "col-3"], [1, "img-fluid", 2, "border-radius", "50%", 3, "src"], [1, "btn", "btn-secondary", 3, "click"]], template: function SelectRiskProfileModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function SelectRiskProfileModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function SelectRiskProfileModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2)(3, "div", 3)(4, "div", 4);
        i0.ɵɵrepeaterCreate(5, SelectRiskProfileModalComponent_For_6_Template, 10, 10, "div", 5, _forTrack0);
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(7, "div", 6)(8, "div", 7)(9, "div", 8);
        i0.ɵɵlistener("click", function SelectRiskProfileModalComponent_Template_div_click_9_listener() { return ctx.exitModalHandler(); });
        i0.ɵɵtext(10, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(11, SelectRiskProfileModalComponent_Conditional_11_Template, 2, 0, "div", 9);
        i0.ɵɵelementStart(12, "div", 10);
        i0.ɵɵlistener("click", function SelectRiskProfileModalComponent_Template_div_click_12_listener() { return ctx.forward(); });
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵproperty("modalBaseClass", "modal-fix-scroll")("open", ctx.open);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Select Risk Profile");
        i0.ɵɵadvance(4);
        i0.ɵɵrepeater(ctx.riskProfileItems);
        i0.ɵɵadvance(6);
        i0.ɵɵconditional(ctx.currentWizardStepIndex ? 11 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c0, ctx.disableSubmission))("innerText", "Next");
    } }, dependencies: [i2.NgClass, i3.IconDirective, i4.ModalBaseComponent, i5.SimpleModalHeaderComponent], encapsulation: 2 });
